import { useCallback, useEffect, useState } from "react";
import Cookies from "js-cookie";

import { GET_ALL_EMPLOYEES_NAME } from "../../../config/Endpoints.js";
import { getApi } from "../../utils/api.ts";
import type { SelectOption } from "../../components/ui/index.ts";

type EmpDirectoryRow = { id: number; empName: string };

type EmpDirectoryResponse = {
  data?: EmpDirectoryRow[];
};

export function useEmployeesList(enabled = true) {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEmployees = useCallback(async () => {
    setLoading(true);
    setError(null);
    const accessToken = Cookies.get("accessToken");
    try {
      const res = await getApi<EmpDirectoryResponse | EmpDirectoryRow[]>(
        GET_ALL_EMPLOYEES_NAME,
        accessToken,
      );
      const root = res.data as unknown;
      const users: EmpDirectoryRow[] = Array.isArray(root)
        ? (root as EmpDirectoryRow[])
        : Array.isArray((root as EmpDirectoryResponse)?.data)
          ? ((root as EmpDirectoryResponse).data as EmpDirectoryRow[])
          : [];
      setOptions(
        users.map((u) => ({
          value: String(u.id),
          label: u.empName ?? `Employee ${u.id}`,
        })),
      );
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load employees");
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) void fetchEmployees();
  }, [fetchEmployees, enabled]);

  return { options, loading, error, refetch: fetchEmployees };
}
